module.exports = __webpack_public_path__ + "img/hongkong_002.7b754086.jpg";